module.exports = __webpack_public_path__ + "static/media/Visa.b7b8e9fd.svg";